module.exports = function() {
  return new Worker(__webpack_public_path__ + "7787e886b25278d8bd8f.worker.js");
};